// extracted by mini-css-extract-plugin
module.exports = {"formWrapper":"FormFieldTranslationsNew_formWrapper__1I4Dv"};